import React, { Fragment } from 'react';
import Image from 'next/image';
import Button from '../next-ui/Button';
import { MdClose } from 'react-icons/md';
import { Dialog, Transition } from '@headlessui/react';

function ImageViewDialog(props) {
  const { imageUrl, isOpen, alt = '', onClose } = props;
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="flex min-h-full items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="relative flex transform items-start justify-center overflow-hidden rounded-2xl bg-black shadow-xl transition-all">
                <Image
                  width={screen.availWidth * 0.8}
                  height={screen.availHeight * 0.75}
                  sizes="(max-width: 640px) 100vw, 80vw"
                  src={imageUrl || ''}
                  alt={alt}
                  className="w-screen rounded-md object-contain object-center lg:max-h-[75vh] lg:max-w-[80vw]"
                  // !relative max-h-[75vh] w-screen max-w-[80vw]
                />
                <div className="absolute right-2 top-2">
                  <Button
                    variant="icon"
                    onClick={onClose}
                    className="bg-body-background">
                    <MdClose className="h-8 w-8" />
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default ImageViewDialog;
